import type { JSX } from 'react';

import { translationKey } from '@change-corgi/core/i18n';

import { useSharingTools } from '../../../../hooks/useSharingTools';
import { SharingToolsCardWrapperVariant2 } from '../../../SharingToolsCardWrapper/variant2';
import { SocialContentPreview } from '../SocialContentPreview';

export function SocialContentCard(): JSX.Element {
	const { data, actions } = useSharingTools();
	return (
		<SharingToolsCardWrapperVariant2
			Preview={<SocialContentPreview isLoading={data.shareVisual.isLoading} shareVisual={data.shareVisual.image} />}
			titleKey={translationKey('corgi.petition.starter_dashboard_v2.sharing_tools.social_content.title')}
			descriptionKey={translationKey('corgi.petition.starter_dashboard_v2.sharing_tools.social_content.description')}
			primaryActionTextKey={translationKey(
				'corgi.petition.starter_dashboard_v2.sharing_tools.social_content.primary_action_text',
			)}
			primaryActionOnClick={actions.navigateToShareVisual}
		/>
	);
}
